<template>
  <div class="card-loteFrete-produto-repeticao">
    <g-titulo-steps
    titulo="INFORMAÇÕES SOBRE LOTE E FRETE "
    subtitulo="Forneça informações sobre o frete e o lote"
    :imagemEmpresa = imagemEmpresa
    />

    <div class="header-loteFrete-conteudo espacamento-fluxos">
      <div class="loteFrete-lote">
        <div class="lote-titulo titulo-conteudo-fluxos"> Lote </div>
        <PDropDown
          class="lote-input input-label"
          :disabled="DesativaLote || copiaOrcamentoQuantidade"
          v-model="loteSelecionado"
          inputStyle="text-align:text-left"
          :options="loteArray"
          optionLabel="text"
          optionValue="enum"
          @change="atualizaSequencia"
        />
      </div>

      <div class="loteFrete-sequencia">
        <div class="sequencia-titulo titulo-conteudo-fluxos"> Sequência </div>
        <PDropDown
          class="sequencia-input input-label"
          v-model="sequenciaSelecionada"
          :options="sequenciaArray"
          :disabled="DesativaSequencia || copiaOrcamentoQuantidade"
          @change="atualizaLote"
          optionLabel="campo"
          optionValue="value"
        />
      </div>

      <div class="loteFrete-frete">
        <div class="frete-titulo titulo-conteudo-fluxos"> Frete </div>
        <PDropDown
          class="frete-input input-label"
          v-model="freteSelecionado"
          :options="freteArray"
          optionLabel="text"
          optionValue="value"
          @change="verificaLote"
          :disabled="copiaOrcamentoQuantidade"
        />
      </div>

      <div :class="`loteFrete-cep ${freteSelecionado === 1 ? 'invisivel' : ''}`">
        <div class="cep-titulo titulo-conteudo-fluxos"> CEP </div>
        <PInputMask
          class="cep-input input-label"
          unmask
          autoClear
          mask="99999-999"
          v-model="cepValue"
          :disabled="freteSelecionado === 2 || copiaOrcamentoQuantidade"
          @blur="getCEP"

        />
      </div>

      <div :class="`estado-cidade ${freteSelecionado === 1 ? 'invisivel' : ''}`">
        <div class="loteFrete-estado">
          <div class="estado-titulo titulo-conteudo-fluxos"> UF </div>
          <!-- <PInputText
            class="estado-input input-label"
            v-model="ufValue"
            :disabled="copiaOrcamentoQuantidade || freteSelecionado === 2"
          /> -->
          <PDropDown
              class="estado-input input-label"
              placeholder="UF"
              optionValue="id"
              optionLabel="siglaEstado"
              :options="EstadoArray"
              v-model="EstadoId"
              :filter="true"
              @change="buscarcidade"
              :disabled = "freteSelecionado === 2"
              />
        </div>

        <div class="loteFrete-cidade">
          <div class="cidade-titulo titulo-conteudo-fluxos"> Cidade </div>
          <!-- <PInputText
            class="cidade-input input-label"
            v-model="cidadeValue"
            :disabled="copiaOrcamentoQuantidade || freteSelecionado === 2"
          /> -->
          <PDropDown
              class="cidade-input input-label"
              placeholder="Cidade"
              optionValue="id"
              optionLabel="nomeCidade"
              :options="CidadeArray"
              v-model="CidadeId"
              :filter="true"
              :disabled = "this.EstadoId == null || freteSelecionado === 2"
              />
        </div>
      </div>

      <div :class="`loteFrete-tipo-frete ${freteSelecionado === 1 ? 'invisivel' : ''}`">
        <div class="tipo-frete-titulo titulo-conteudo-fluxos"> Tipo Frete </div>
        <PDropDown
          class="tipo-frete-input input-label"
          v-model="tipoFreteSelecionado"
          :options="TipoFreteArray"
          optionLabel="text"
          optionValue="value"
          :disabled = "copiaOrcamentoQuantidade"
        />
      </div>
    </div>

    <div class="buttons-next-back">
      <div class="button-next">
        <g-button
        tipo="amarelo"
        altura="35px"
        largura="100%"
        negritoTexto 
        @click="step3" 
        ref="botaoContinuar"
        >
          CONTINUAR
        </g-button>
      </div>

      <div class="button-back">
        <g-button 
        tipo="cinza" 
        altura="35px"
        largura="100%"
        negritoTexto 
        v-on:acao="voltarstep1" 
        >
          VOLTAR
        </g-button>
      </div>
      <div class="button-back">
        <g-button 
        tipo="cinza" 
        altura="35px"
        largura="100%"
        negritoTexto 
        @click="abrePopupCancelarOrcamento"
        >
          CANCELAR
        </g-button>
      </div>
    </div>
    <PDialog :showHeader="false" :closable="false" v-model:visible="popupCancelaOrc" :modal="true">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Deseja cancelar esse orçamento? </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="fechaPopupCancelar"
          >
            NÃO
          </g-button>
        </div>
        <div>
          <g-button
          tipo="amarelo"
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="cancelaOrcamento"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>
  </div>
</template>

<script>
import LoteFreteRepeticao from "./LoteFreteRepeticao.js";
export default LoteFreteRepeticao;
</script>

<style scoped>
.invisivel {
  visibility: hidden;
}

.espacamento-fluxos {
  margin-top: 50px;
}

@media (min-width:310px) {
.header-loteFrete-conteudo {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(8, auto);
  grid-column-gap: 20px;
  grid-row-gap: 10px;
}
.loteFrete-lote { grid-area: 1 / 1 / 2 / 3; }
.loteFrete-sequencia { grid-area: 2 / 1 / 3 / 3; }
.loteFrete-frete { grid-area: 3 / 1 / 4 / 3; }
.loteFrete-cep { grid-area: 4 / 1 / 5 / 3;}
.estado-cidade { grid-area: 5 / 1 / 6 / 3; }
.loteFrete-tipo-frete { grid-area: 6 / 1 / 7 / 3; }
.estado-cidade { flex-direction: column; }
}

@media (min-width:368px) {
.header-loteFrete-conteudo {
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(5, auto);
}
.loteFrete-lote { grid-area: 1 / 1 / 2 / 2; }
.loteFrete-sequencia { grid-area: 1 / 2 / 2 / 3; }
.loteFrete-frete { grid-area: 2 / 1 / 3 / 3; }
.loteFrete-cep { grid-area: 4 / 1 / 5 / 3; }
.estado-cidade {
  grid-area: 3 / 1 / 4 / 3;
  display: flex;
  column-gap: 20px;
  flex-direction: row;
}
.loteFrete-tipo-frete { grid-area: 5 / 1 / 6 / 3; }

.loteFrete-estado { width: 30%; }
.loteFrete-cidade { width: 70%; }
.loteFrete-frete { width: 100%; }
.loteFrete-cep { width: 100%; }
}

@media (min-width:600px) {
.header-loteFrete-conteudo {
  grid-template-columns: 60% minmax(4em, 1fr);
  grid-template-rows: repeat(3, auto);
  grid-column-gap: 20px;
}
.loteFrete-lote { grid-area: 1 / 1 / 2 / 2; }
.loteFrete-sequencia { grid-area: 1 / 2 / 2 / 3; }
.loteFrete-frete { grid-area: 2 / 1 / 3 / 2; }
.loteFrete-cep { grid-area: 2 / 2 / 3 / 3; }
.estado-cidade { grid-area: 3 / 1 / 4 / 2; }
.loteFrete-tipo-frete { grid-area: 3 / 2 / 4 / 3; }
}

@media (min-width:801px) {
.header-loteFrete-conteudo {
  grid-template-columns: repeat(4, minmax(4em, 1fr));
  grid-template-rows: repeat(2, auto);
}
.loteFrete-lote { grid-area: 1 / 1 / 2 / 2; }
.loteFrete-sequencia { grid-area: 1 / 2 / 2 / 3; }
.loteFrete-frete { grid-area: 1 / 3 / 2 / 5; }
.loteFrete-cep { grid-area: 2 / 1 / 3 / 2; }
.estado-cidade { grid-area: 2 / 2 / 3 / 4; }
.loteFrete-tipo-frete { grid-area: 2 / 4 / 3 / 5; }
}

@media (min-width:1025px) {

}

@media (min-width:1281px) {
}

@media (min-width:1500px) {
}
</style>
